import { atom, selector } from "recoil";
import { createDataRequest, assignDataRequest, completeDataRequest } from "../../../api/controller/FaultLogController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const guestFaultLogListState = atom({
    key: 'guestFaultLogListState',
    default: [],
})
export const guestFaultLogCategoryState = atom({
	key: 'guestFaultLogCategoryState',
	default:{
		data:[],
		ovf:false,
	}
})
export const guestFaultLogGroupState = atom({
	key: 'guestFaultLogGroupState',
	default:{
		data:[],
		ovf:false,
	}
})

export const modalConfigDefault = { size: "md", wizard: false }

export const guestFaultLogFilterState = selector({
    key: 'guestFaultLogFilterState',
    get: () => ([])
})


export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: assignDataRequest, closeOnSubmit: true }, { name: 'Default Update', action: completeDataRequest, closeOnSubmit: true } ],
    view: [ { name: 'Default View' } ],
}

export const guestFaultLogDataStructureState = selector({
    key: 'guestFaultLogDataStructureState',
    get: ({ get }) => (
        [

			{ 
                label: 'Category',
                type: 'nestedselect',
                field: 'category_text',
                rootValue: true,
                order: { table: 1, form: 1 }, 
                table: { customRender: (_, params) => params?.data["category_text"], },
                create: [{ enabled: true, size: { xs: 12, md: 12 }, attributes: { enableRootSelect: false, enableMidSelect: false } }], update: [{ enabled: false }], view: ['same_as:create.0'], 
				list: get(guestFaultLogCategoryState),
            },
			{ 
                label: 'Details',
                type: 'textarea',
                order: { form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 } , attributes: { maxLength: '225', rows: '3' } }], update: [{ enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Attachments',
                type: 'repeater',
                order: { form: 4 },
                create: [{ enabled: true, size: { xs: 12, md: 12 }, deleteBtnSize: 2, repeatLabel: false }], update: [{ enabled: false }], view: ['same_as:create.0'],
                children: [
                    { 
                		label: 'Name',
                		type: 'text',
                		order: { form: 1 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: [{ enabled: false }], view: ['same_as:create.0'], 
            		},
					{ 
                		label: 'File',
                		type: 'file',
                		order: { form: 2 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: [{ enabled: false }], view: ['same_as:create.0'], 
            		},
					
                ]
            },
			{ 
                label: 'Response',
                type: 'textarea',
                order: { form: 6 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 12 } , attributes: { maxLength: '225', rows: '3' }, validations: 'hidden_if:Response,null' }], 
            },
			{ 
                label: 'Logged Time',
                field: 'created_time',
                type: 'datepicker',
                order: { table: 3, form: 6 }, 
				table: { maxWidth: 220, dateFormat: 'D MMM | HH:mm' },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 6 } }], 
            },
			{ 
                label: 'Assigned Time',
                field: 'assigned_at',
                type: 'datepicker',
                order: { form: 7 }, 
				table: { dateFormat: 'D MMM | HH:mm' },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:AssignedTime,null' }], 
            },
			{ 
                label: 'Completed Time',
                field: 'completed_at',
                type: 'datepicker',
                order: { form: 8 }, 
				table: { dateFormat: 'D MMM | HH:mm' },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:CompletedTime,null' }], 
            },
			{ 
                label: 'Status',
                type: 'text',
                order: { table: 4, form: 9 }, 
                table: { maxWidth: 200 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 12 }  }], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
